export default __webpack_public_path__ + "static/media/meal-black.9d306cac.svg";